module.exports = __webpack_public_path__ + "static/media/zuri.2c89c967.png";